import { REACT_APP_NOTIFICATION_URL } from 'config';
import { httpClient } from 'features/auth/utils/http';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const useNotificationsUnreadCountQueryKey = 'useNotificationsUnreadCountQueryKey';

const fetchNotificationsUnreadCount = async () => {
  const result = await httpClient.get<number | undefined | null>(
    `${REACT_APP_NOTIFICATION_URL}/notifications/unread/count `
  );

  return result.data;
};

export const useNotificationsUnreadCountQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof fetchNotificationsUnreadCount>>,
      QueryError,
      Awaited<ReturnType<typeof fetchNotificationsUnreadCount>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery([useNotificationsUnreadCountQueryKey, ...(queryKey ?? [])], () => fetchNotificationsUnreadCount(), options);
